import type {MixRgbSockets} from "#material/nodes/color/mix-rgb/definition"
import type {MaterialNodeParameters, MaterialNodeSettings} from "#material/sockets/parameters"
import type {Version} from "@cm/graph-v3"
import {z} from "zod/v4-mini"

export const rgbBlendType = z.enum([
    "MIX",
    "ADD",
    "SUBTRACT",
    "MULTIPLY",
    "SCREEN",
    "DIVIDE",
    "DIFFERENCE",
    "EXCLUSION",
    "DARKEN",
    "LIGHTEN",
    "OVERLAY",
    "DODGE",
    "BURN",
    "HUE",
    "SATURATION",
    "VALUE",
    "COLOR",
    "SOFT_LIGHT",
    "LINEAR_LIGHT",
])

export type RgbBlendType =
    | "MIX"
    | "ADD"
    | "SUBTRACT"
    | "MULTIPLY"
    | "SCREEN"
    | "DIVIDE"
    | "DIFFERENCE"
    | "EXCLUSION"
    | "DARKEN"
    | "LIGHTEN"
    | "OVERLAY"
    | "DODGE"
    | "BURN"
    | "HUE"
    | "SATURATION"
    | "VALUE"
    | "COLOR"
    | "SOFT_LIGHT"
    | "LINEAR_LIGHT"

/**
 * The platform used to spell Blender's BURN and DODGE with a Color prefix, which meant a material using
 * either could not be sent back. Stored graphs still carry the old spelling until they are next saved.
 */
export type StoredBlendType = RgbBlendType | "COLOR_BURN" | "COLOR_DODGE"

export const blendTypeAsBlenderSpellsIt = (blendType: StoredBlendType | undefined): RgbBlendType | undefined => {
    if (blendType === "COLOR_BURN") return "BURN"
    if (blendType === "COLOR_DODGE") return "DODGE"
    return blendType
}

type Current = MaterialNodeParameters<MixRgbSockets>
type Previous = Omit<Current, "settings"> & {settings: Omit<MaterialNodeSettings<MixRgbSockets>, "blendType"> & {blendType?: StoredBlendType}}

export const renameBlendTypesToBlender: Version<Previous, Current> = {
    toNextVersion: ({settings = {}, ...parameters}) => ({...parameters, settings: {...settings, blendType: blendTypeAsBlenderSpellsIt(settings.blendType)}}),
}
